import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, SendDiagonal } from 'iconoir-react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import { criarReserva } from '../services/api';

const Reserva = ({ brand }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome_cliente: '',
    celular: '',
    data_reserva: '',
    horario: '',
    quantidade_pessoas: '',
    observacoes: ''
  });
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErro('');
  };

  const getTodayString = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const validar = () => {
    if (!formData.nome_cliente.trim() || formData.nome_cliente.trim().length < 2) return 'Informe seu nome (mínimo 2 caracteres)';
    if (!formData.celular.trim()) return 'Informe seu celular';
    if (!formData.data_reserva) return 'Selecione a data da reserva';
    if (formData.data_reserva < getTodayString()) return 'A data deve ser hoje ou futura';
    if (!formData.horario) return 'Selecione o horário';
    if (!formData.quantidade_pessoas || parseInt(formData.quantidade_pessoas) < 1) return 'Informe a quantidade de pessoas';
    if (formData.observacoes && formData.observacoes.length > 500) return 'Observações devem ter no máximo 500 caracteres';
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const erroValidacao = validar();
    if (erroValidacao) {
      setErro(erroValidacao);
      return;
    }

    setEnviando(true);
    setErro('');

    try {
      const result = await criarReserva(brand, {
        ...formData,
        quantidade_pessoas: parseInt(formData.quantidade_pessoas)
      });

      if (result && result.success) {
        setSucesso(true);
      } else {
        setErro(result?.error || result?.message || 'Erro ao enviar reserva. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro ao enviar reserva. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  if (sucesso) {
    return (
      <div className="bg-light" style={{ backgroundColor: '#f3f4f6', minHeight: '100vh' }}>
        <div className="container py-3">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <div className="p-4 text-center" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                <div className="mb-3">
                  <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#d1fae5', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}>
                    <Calendar width={32} height={32} style={{ color: '#059669' }} />
                  </div>
                </div>
                <h4 style={{ fontWeight: 700, color: '#1a1a1a' }}>Reserva Enviada!</h4>
                <p style={{ color: '#6b7280', fontSize: '0.95rem' }}>
                  Sua reserva foi registrada com sucesso. O restaurante irá confirmar em breve.
                </p>
                <div className="mt-3 p-3" style={{ background: '#f9fafb', borderRadius: '8px', textAlign: 'left' }}>
                  <div className="mb-2"><strong>Nome:</strong> {formData.nome_cliente}</div>
                  <div className="mb-2"><strong>Data:</strong> {formData.data_reserva.split('-').reverse().join('/')}</div>
                  <div className="mb-2"><strong>Horário:</strong> {formData.horario}</div>
                  <div><strong>Pessoas:</strong> {formData.quantidade_pessoas}</div>
                </div>
                <div className="mt-4 d-grid gap-2">
                  <button className="btn btn-primary" onClick={() => { setSucesso(false); setFormData({ nome_cliente: '', celular: '', data_reserva: '', horario: '', quantidade_pessoas: '', observacoes: '' }); }}>
                    Fazer Nova Reserva
                  </button>
                  <Link to="/loja" className="btn btn-outline-secondary">
                    Voltar para a Loja
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-light" style={{ backgroundColor: '#f3f4f6', minHeight: '100vh' }}>
      <div className="container py-3">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            {/* Header */}
            <div className="mb-3 d-flex align-items-center" style={{ gap: '12px' }}>
              <button className="btn btn-link p-0 text-dark" onClick={() => navigate(-1)}>
                <ArrowLeft width={24} height={24} />
              </button>
              <h5 className="mb-0" style={{ fontWeight: 700 }}>Reservar Mesa</h5>
            </div>

            {/* Form */}
            <div className="p-3" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
              {erro && (
                <div className="alert alert-danger py-2 px-3" style={{ fontSize: '0.9rem', borderRadius: '8px' }}>
                  {erro}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label small fw-bold text-muted d-block text-start">
                    Seu Nome *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="nome_cliente"
                    value={formData.nome_cliente}
                    onChange={handleChange}
                    placeholder="Nome completo"
                    required
                    style={{ borderRadius: '8px' }}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-bold text-muted d-block text-start">
                    Celular *
                  </label>
                  <PhoneInput
                    country="br"
                    value={formData.celular}
                    onChange={(value) => setFormData(prev => ({ ...prev, celular: value }))}
                    inputClass="phone-input-field"
                    buttonClass="phone-input-btn"
                    preferredCountries={['br', 'us', 'ar', 'pt']}
                    enableSearch
                    searchPlaceholder="Buscar país..."
                    searchNotFound="País não encontrado"
                  />
                </div>

                <div className="row g-2 mb-3">
                  <div className="col-6">
                    <label className="form-label small fw-bold text-muted d-block text-start">
                      Data *
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="data_reserva"
                      value={formData.data_reserva}
                      onChange={handleChange}
                      min={getTodayString()}
                      required
                      style={{ borderRadius: '8px' }}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label small fw-bold text-muted d-block text-start">
                      Horário *
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="horario"
                      value={formData.horario}
                      onChange={handleChange}
                      required
                      style={{ borderRadius: '8px' }}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-bold text-muted d-block text-start">
                    Quantidade de Pessoas *
                  </label>
                  <select
                    className="form-select"
                    name="quantidade_pessoas"
                    value={formData.quantidade_pessoas}
                    onChange={handleChange}
                    required
                    style={{ borderRadius: '8px' }}
                  >
                    <option value="">Selecione</option>
                    {Array.from({ length: 50 }, (_, i) => i + 1).map(n => (
                      <option key={n} value={n}>{n} {n === 1 ? 'pessoa' : 'pessoas'}</option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-bold text-muted d-block text-start">
                    Observações
                  </label>
                  <textarea
                    className="form-control"
                    name="observacoes"
                    value={formData.observacoes}
                    onChange={handleChange}
                    rows="3"
                    maxLength={500}
                    placeholder="Alguma preferência ou informação adicional?"
                    style={{ borderRadius: '8px' }}
                  />
                  <small className="text-muted">{formData.observacoes.length}/500</small>
                </div>

                <button
                  type="submit"
                  className="btn w-100"
                  disabled={enviando}
                  style={{ borderRadius: '8px', padding: '12px', fontWeight: 600, backgroundColor: '#0039ff', color: '#fff', border: 'none' }}
                >
                  {enviando ? (
                    <><span className="spinner-border spinner-border-sm me-2"></span>Enviando...</>
                  ) : (
                    <><SendDiagonal width={16} height={16} className="me-2" />Enviar Reserva</>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reserva;
